import OrganizerDataRow from './OrganizerDataRow';
import { observer } from 'mobx-react-lite';
import AttendeeTrackingDetails from 'owa-calendar-forms-common/lib/components/AttendeeTrackingDetails';
import getCalendarOwnerFromItem from 'owa-calendar-forms-common/lib/utils/getCalendarOwnerFromItem';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import * as React from 'react';

const styles = require('./CalendarItemPeek.scss');
const classNames = require('classnames');

interface PeekEventOrganizerRowProps {
    item: CalendarEvent;
    onAttendeeTrackingClicked?: () => void;
}

export default observer(function PeekEventOrganizerRow(props: PeekEventOrganizerRowProps) {
    const { item, onAttendeeTrackingClicked } = props;

    const showTrackingDetails = !item.IsCancelled && item.IsResponseRequested;
    const calendarOwner = getCalendarOwnerFromItem(item);
    const inviteeName =
        calendarOwner.EmailAddress == getUserConfiguration().SessionSettings.UserEmailAddress
            ? undefined
            : calendarOwner;

    return (
        <div
            className={classNames(styles.organizerRowContainer, {
                [styles.withAttendeeTracking]: showTrackingDetails,
            })}>
            <OrganizerDataRow
                organizer={item.Organizer.Mailbox}
                isOrganizer={item.IsOrganizer}
                invitee={inviteeName}
            />
            {showTrackingDetails && (
                <AttendeeTrackingDetails
                    event={item}
                    className={styles.attendeesTrackingDetailsContainer}
                    onAttendeeTrackingClicked={onAttendeeTrackingClicked}
                />
            )}
        </div>
    );
});
